<div class="modal-header">
    <h4 class="modal-title">{{ 'UserScreenshots' | translate }} - {{ userName }}</h4>
    <div>
        <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
    </div>
</div>

<div class="modal-body" [ngClass]="{'pb-0': totalRecords > 0}">
    <div *ngIf="!(httpService.getLoading('screenshotsLoader')) && totalRecords > 0">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4" style="margin-bottom: 1.5rem;"
                *ngFor="let screenshot of screenshots; let i = index" [style.animation-delay.ms]="i * 50">
                <div class="screenshot-card">
                    <div class="screenshot-image-wrapper" role="button"
                        (click)="publicService.openImage('Screenshot', screenshot.screenshot)">
                        <img [lazyLoad]="screenshot.screenshot" [defaultImage]="'assets/img/placeholder-loading.svg'"
                            [errorImage]="'assets/img/placeholder-not-found.svg'" class="screenshot-image"
                            alt="Screenshot">
                        <div class="screenshot-overlay">
                            <i class="fe fe-maximize-2 fs-1 text-white"></i>
                        </div>
                    </div>
                    <div class="screenshot-info">
                        <i class="fe fe-clock me-2"></i>
                        <span>{{ screenshot.insert_date | date:'dd/MM/yy • h:mm a' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="(httpService.getLoading('screenshotsLoader'))">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4" style="margin-bottom: 1.5rem;"
                *ngFor="let number of [].constructor(30)">
                <ngx-skeleton-loader appearance="line" animation="progress-dark"
                    [theme]="{width:'100%',height:'200px','border-radius':'12px'}"></ngx-skeleton-loader>
                <ngx-skeleton-loader appearance="line" animation="progress-dark"
                    [theme]="{width:'60%',height:'16px','border-radius':'4px'}"></ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <!-- pagination -->
    <app-pagination [isLoading]="httpService.getLoading('screenshotsLoader')" (pageChange)="list($event)"
        [totalCount]="totalCount" [totalRecords]="totalRecords" [size]="size"></app-pagination>
</div>